import React from 'react';
import UserRelationButton from '../../../User/Components/UserRelationButton/UserRelationButton';
import styles from './SearchCaseContactItem.module.scss';

export interface SearchCaseContactItemProps {
	iconUrl?: string;
	textRow1?: string;
	textRow2?: string;
	textRow3?: string;
	type?: string;
	userId?: string;
	workplaceId: string;
	workplaceMemberId?: string;
	workplaceMemberUserRelation?: {
		id: string;
	};
}

interface Props {
	item: SearchCaseContactItemProps;
	onClick: (workplaceId?: string, workplaceMemberId?: string) => void;
	patientId: string;
}

const SearchCaseContactItem: React.FC<Props> = ({
	item,
	onClick,
	patientId,
}) => {
	return (
		<div
			className={styles.wrapper}
			onClick={() =>
				onClick(
					item.workplaceId ?? undefined,
					item.workplaceMemberId ?? undefined,
				)
			}
		>
			<div className={styles.innerWrapper}>
				<div className={styles.imageWrapper}>
					<img src={item.iconUrl} alt={item.textRow1} />
				</div>
				<div className={styles.content}>
					{item.textRow1 && <div className={styles.title}>{item.textRow1}</div>}
					{item.textRow2 && (
						<div className={styles.subtitle}>{item.textRow2}</div>
					)}
					{item.textRow3 && (
						<div className={styles.subtitle}>{item.textRow3}</div>
					)}
				</div>
			</div>
			<UserRelationButton
				workplaceId={item.workplaceId}
				userId={item.userId}
				patientId={patientId}
				fetchFavorite={false}
				workplaceMemberUserRelationId={item?.workplaceMemberUserRelation?.id}
			/>
		</div>
	);
};

export default SearchCaseContactItem;
